<div class="dropdown d-inline">
  <button
    aria-label="vedi azioni da compiere sulla pagina"
    class="btn btn-dropdown dropdown-toggle text-decoration-underline d-inline-flex align-items-center fs-0"
    type="button"
    id="viewActions"
    data-bs-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <svg class="icon" aria-hidden="true">
      <use
        xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-more-items"
      ></use>
    </svg>
    <small>Vedi azioni</small>
  </button>
  <div class="dropdown-menu shadow-lg" aria-labelledby="viewActions">
    <div class="link-list-wrapper">
      <ul class="link-list" role="menu">
        <li role="none">
          <a class="list-item" role="menuitem" (click)="print()">
            <svg class="icon" aria-hidden="true">
              <use
                xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-print"
              ></use>
            </svg>
            <span>Stampa</span>
          </a>
        </li>
        <li role="none">
          <a class="list-item" role="menuitem" (click)="listen()">
            <svg class="icon" aria-hidden="true">
              <use
                xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-hearing"
              ></use>
            </svg>
            <span>{{ isPlaying ? "Pausa" : "Ascolta" }}</span>
          </a>
        </li>
        <li role="none">
          <a
            class="list-item"
            [href]="'mailto:?subject=' + mailObject + '&body=' + path"
            role="menuitem"
          >
            <svg class="icon" aria-hidden="true">
              <use
                xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-mail"
              ></use>
            </svg>
            <span>Invia</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
